<template>
	<div class="finance container-fluid py-2">
		<div class="row">
			<div class="col-md-12 p-0">
				
                <div class="row" v-if="false">
                    <div class="mb-3">          
                        <el-collapse style="margin-top: -21px;">
                            <el-collapse-item>
                                <template slot="title">
                                    <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                                </template>
                                <el-form label-position="top" label-width="100px" class="ml-2">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <el-form-item label="Bulan:">
                                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-2">
                                            <el-form-item label="Tahun:">
                                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-3">
                                            <el-form-item label="Group:">
                                                <el-radio-group v-model="group" size="small" name="group">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.group" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-2">	
                                            <el-form-item label=" ">
                                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                                            </el-form-item>
                                        </div>
                                    </div>

                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>

                <div class="mb-0" style="margin-top:0px;">   
                    <div class="mt-0 ml-1 mr-1 mb-0">
                        <ReportResultTable v-if="false" :reportname="'PLReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
                        <div class="row">
                            <div class="col-md-12 pr-0 pl-0" :style="'overflow-x: auto; min-height:150px;height:' + tableHeight + ';'">
                                <table class="app-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(value, key, idx) in summaryData" :key="key" class="text-right">
                                                {{ idx > 5 ? formatNum(value) : '' }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-for="(value, idx) in reportdata.SAPProductId" :key="idx" class="text-center">
                                                {{ idx > 5 ? value : '' }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-for="(item, idx) in reportdata.columns" :key="idx" :class="idx > 5 ? 'sticky-table-header' : 'sticky-table-header' " :style="idx == 5 ? 'min-width:500px;' : '' ">   
                                                <div v-if="idx == 2" class="filter-popover" style="width: 130px;">
                                                    <div>{{ item.title }}</div>
                                                    <el-popover placement="bottom" width="450" v-model="popovervisibility.fungsi">
                                                        <div class="row p-2">
                                                            <div class="col-md-12">
                                                                <h5>Fungsi</h5>
                                                                <el-input v-model="searchTextFungsi2" placeholder="Search Fungsi"></el-input>
                                                                <hr>
                                                                <el-checkbox v-model="selectAllFungsi" @change="handleSelectAllFungsi">Check All</el-checkbox>
                                                                <hr>
                                                                <div style="max-height: 400px; overflow-y: auto;">
                                                                    <el-checkbox-group v-model="selectedOptionsFungsi">
                                                                        <el-checkbox v-for="option in filteredOptionsFungsi" :key="option.Fungsi" :label="option.Fungsi">
                                                                            <div class="checkbox-text">{{ option.Fungsi }}</div>
                                                                        </el-checkbox>
                                                                    </el-checkbox-group>
                                                                </div>
                                                                <hr>
                                                                <el-button type="primary" @click="submitSelection()">Apply</el-button>
                                                            </div>
                                                        </div>
                                                        <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                    </el-popover>
                                                </div>
                                                <div v-else-if="idx == 3" class="filter-popover" style="min-width: 170px;">
                                                    <div>{{ item.title }}</div>
                                                    <el-popover placement="bottom" width="450" v-model="popovervisibility.tipe">
                                                        <div class="row p-2">
                                                            <div class="col-md-12">
                                                                <h5>Tipe</h5>
                                                                <el-input v-model="searchTextTipe" placeholder="Search Type"></el-input>
                                                                <hr>
                                                                <el-checkbox v-model="selectAllTipe" @change="handleSelectAllTipe">Check All</el-checkbox>
                                                                <hr>
                                                                <div style="max-height: 400px; overflow-y: auto;">
                                                                    <el-checkbox-group v-model="selectedOptionsTipe">
                                                                        <el-checkbox v-for="option in filteredOptionsTipe" :key="option.Tipe" :label="option.Tipe">
                                                                            <div class="checkbox-text">{{ option.Tipe }}</div>
                                                                        </el-checkbox>
                                                                    </el-checkbox-group>
                                                                </div>
                                                                <hr>
                                                                <el-button type="primary" @click="submitSelection()">Apply</el-button>
                                                            </div>
                                                        </div>
                                                        <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                    </el-popover>
                                                </div>
                                                <div v-else-if="idx == 4" class="filter-popover" style="min-width: 130px;">
                                                    <div>{{ item.title }}</div>
                                                    <el-popover placement="bottom" width="450" v-model="popovervisibility.area">
                                                        <div class="row p-2">
                                                            <div class="col-md-12">
                                                                <h5>Sales Area</h5>
                                                                <el-input v-model="searchTextArea" placeholder="Search Sales Area"></el-input>
                                                                <hr>
                                                                <el-checkbox v-model="selectAllArea" @change="handleSelectAllArea">Check All</el-checkbox>
                                                                <hr>
                                                                <div style="max-height: 400px; overflow-y: auto;">
                                                                    <el-checkbox-group v-model="selectedOptionsArea">
                                                                        <el-checkbox v-for="option in filteredOptionsArea" :key="option.Name" :label="option.Value">
                                                                            <div class="checkbox-text">{{ option.Name }}</div>
                                                                        </el-checkbox>
                                                                    </el-checkbox-group>
                                                                </div>
                                                                <hr>
                                                                <el-button type="primary" @click="submitSelection()">Apply</el-button>
                                                            </div>
                                                        </div>
                                                        <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                    </el-popover>
                                                </div>
                                                <div v-else-if="idx == 5" class="filter-popover">
                                                    <div>{{ item.title }}</div>
                                                    <el-popover placement="bottom" width="450" v-model="popovervisibility.unit">
                                                        <div class="row p-2">
                                                            <div class="col-md-12">
                                                                <h5>Unit</h5>
                                                                <el-input v-model="searchTextUnit2" placeholder="Search Unit Name"></el-input>
                                                                <hr>
                                                                <el-checkbox v-model="selectAllUnit" @change="handleSelectAllUnit">Check All</el-checkbox>
                                                                <hr>
                                                                <div style="max-height: 350px; overflow-y: auto;">
                                                                    <el-checkbox-group v-model="selectedOptionsUnit">
                                                                        <el-checkbox v-for="option in filteredOptionsUnit" :key="option.CostCenter" :label="option.CostCenter">
                                                                            <div class="checkbox-text">{{ option.UnitName }}</div>
                                                                        </el-checkbox>
                                                                    </el-checkbox-group>
                                                                </div>
                                                                <hr>
                                                                <el-button type="primary" @click="submitSelection()">Apply</el-button>
                                                            </div>
                                                        </div>
                                                        <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                    </el-popover>
                                                </div>
                                                
                                                <div v-else>
                                                    {{ item.title }}
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item2, idx2) in this.filteredDataAll" :key="idx2">
                                            <td v-for="(item3, idx3) in reportdata.columns" :key="idx3" :class="idx3 > 5 ? 'text-right' : ''" :style="idx3 > 5 ? 'min-width:230px;' : ''">
                                                <div style="background-color: transparent; height: 100%;"  :class="idx3 > 5 ? 'button-cell' : ''">
                                                    {{ (idx3 > 5 ? formatNum(item2[item3.field]) : item2[item3.field]) }}
                                                </div>                                                  
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>
                    </div>
                    <Loader v-if="loading.table"/>
                </div>
					
			</div>
		</div>

	</div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import Finance from '@/components/page/Finance.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		ReportResultTable,
		//VendorReportTab,
		//FinanceReportTab,
        Loader,
	},

    props: ["reportdata"],

	data() {
		return {
            loading: {
				table: false,
                tableDetail: false,
				chart: false,
				isSuccess: false,
                isSuccessDetail: false,
			},
            //reportdata: [],
            //reportdatadetail: [],
            urlRequestParams: '',
            dialogVisible: false,
            category: '',
            unitId: '',
            station: {
                list: [],
            },

            tableHeight: "500px",

            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            options: {
                plant:[],
                costcenter:[],
                fungsi: [],
                tipe: [],
                unit: [],
                salesarea: [
                    { Value:'1', Name:'1' },
                    { Value:'2', Name:'2' },
                    { Value:'3', Name:'3' },
                    { Value:'4', Name:'4' },
                    { Value:'5', Name:'5' },
                ],
                labarugi: [
                    { Value:'profit', Name:'Profit (+)' },
                    { Value:'loss', Name:'Loss (-)' }
                ],
                group:[
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'ytd', name: 'YTD' },
				],
            },


            group : 'monthly',
            filteredDataAll: [],
            summaryData:[],

            //old var
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 

			tabListCustomerReport:[
				{label:'Sales B2B', name: 'sales_b2b', index: '0' },
				{label:'Piutang', name: 'piutang', index: '1' },
			],

			tabListVendorReport:[
				{label:'Hutang', name: 'hutang', index: '10' },
			],

			tabListFinanceReport:[
				{label:'Cash Deposit Clearing', name: 'clearingcash', index: '20' },
				{label:'Kliring VA Pangkalan LPG', name: 'clearingedc', index: '21' },
			],

            popovervisibility: {
                fungsi: false,
                tipe: false,
                area: false,
                unit: false,
                labarugi: false,
            },

            //Fungsi
            selectAllFungsi:false,
            selectedOptionsFungsi: [],
            searchTextFungsi2: "",

            //Tipe
            selectAllTipe:false,
            selectedOptionsTipe: [],
            searchTextTipe: "",

            //Sales Area
            selectAllArea:false,
            selectedOptionsArea: [],
            searchTextArea: "",

            //Unit filter
            selectedOptionsUnit: [], // Menyimpan opsi yang dipilih
            selectAllUnit: false, // Menyimpan status ceklis "Check All" dan "Uncheck All"
            searchTextUnit2: "",

            //Laba Rugi
            selectAllLabaRugi:false,
            selectedOptionsLabaRugi: [],
            searchTextLabaRugi: "",
            
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        //this.$emit('childrenRoute');
        //console.log('reportdata: ' + JSON.stringify(this.reportdata))

        this.setTableHeight();
        window.addEventListener("resize", this.setTableHeight);

        this.generateUnitList()
        this.generateFungsiList()
        this.generateTipeList()
        this.filteredAll()
        
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setTableHeight);
    },
    methods:{

        generateFungsiList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.Fungsi //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						//CostCenter: item.CostCenter,
						Fungsi: item.Fungsi
					});
				}
			});

			this.options.fungsi = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        generateTipeList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.Tipe //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						//CostCenter: item.CostCenter,
						Tipe: item.Tipe
					});
				}
			});

			this.options.tipe = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        generateUnitList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.CostCenter //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						CostCenter: item.CostCenter,
						UnitName: item.UnitName
					});
				}
			});

			this.options.unit = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        handleClose(done) {
            this.$confirm('Are you sure to close ?')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },

		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

        //filter
        handleSelectAllUnit() {
            if (this.selectAllUnit) {
                this.selectedOptionsUnit = this.filteredOptionsUnit.map((option) => option.CostCenter);
            } else {
                this.selectedOptionsUnit = [];
            }
        },
        handleSelectAllArea() {
            if (this.selectAllArea) {
                this.selectedOptionsArea = this.filteredOptionsArea.map((option) => option.Name);
            } else {
                this.selectedOptionsArea = [];
            }
        },
        handleSelectAllTipe() {
            if (this.selectAllTipe) {
                this.selectedOptionsTipe = this.filteredOptionsTipe.map((option) => option.Tipe);
            } else {
                this.selectedOptionsTipe = [];
            }
        },
        handleSelectAllFungsi() {
            if (this.selectAllFungsi) {
                this.selectedOptionsFungsi = this.filteredOptionsFungsi.map((option) => option.Fungsi);
            } else {
                this.selectedOptionsFungsi = [];
            }
        },
        handleSelectAllLabaRugi() {
            if (this.selectAllLabaRugi) {
                this.selectedOptionsLabaRugi = this.filteredOptionsLabaRugi.map((option) => option.Value);
            } else {
                this.selectedOptionsLabaRugi = [];
            }
        },

        filteredAll() {
            /*
            let selectedFungsi = String(this.selectedOptionsFungsi || '').split(','); // hasil: ['PERTASHOP', 'SPBU']
            let selectedTipe = String(this.selectedOptionsTipe || '').split(',');
            let selectedArea = String(this.selectedOptionsArea || '').split(',');
            let selectedUnit = String(this.selectedOptionsUnit || '').split(','); // hasil: ['R2110743', 'R2110285']
            */

            let selectedFungsi = String(this.selectedOptionsFungsi || '').split(',').filter(Boolean);
            let selectedTipe = String(this.selectedOptionsTipe || '').split(',').filter(Boolean);
            let selectedArea = String(this.selectedOptionsArea || '').split(',').filter(Boolean);
            let selectedUnit = String(this.selectedOptionsUnit || '').split(',').filter(Boolean);
            let selectedLabaRugi = String(this.selectedOptionsLabaRugi || '').split(',').filter(Boolean);

            let filteredData = this.reportdata.data.filter(item => {
                // Check if the corresponding array is not empty before applying the filter
                return (selectedFungsi.length === 0 || selectedFungsi.includes(item.Fungsi))
                    && (selectedTipe.length === 0 || selectedTipe.includes(item.Tipe))
                    && (selectedArea.length === 0 || selectedArea.includes(item.SalesArea))
                    && (selectedUnit.length === 0 || selectedUnit.includes(item.CostCenter))
                    ;
                });

            /*
            console.log('selectedFungsi: ' + JSON.stringify(selectedFungsi))
            console.log('selectedTipe: ' + JSON.stringify(selectedTipe))
            console.log('selectedArea: ' + JSON.stringify(selectedArea))
            console.log('selectedUnit: ' + JSON.stringify(selectedUnit))
            console.log('Filtered Data:', JSON.stringify(filteredData));
            */
            
            this.filteredDataAll = filteredData
            this.generateSummary(filteredData)
        },

        generateSummary(filteredData) {
            //Buat array summary
            let columns = this.reportdata.columns.map(column => column.field);
            //console.log('Columns:', columns);

            let summary = {};
            columns.forEach(column => {
                summary[column] = 0;
            });

            filteredData.forEach(item => {
                for (let key in summary) {
                    summary[key] += parseFloat(item[key] || 0);
                }
            });

            this.summaryData = summary

            //console.log('Summary for Columns:', summary); 
        },

        submitSelection() {
            console.log('Opsi yang dipilih:', this.selectedOptionsUnit);
            // hide popover
            this.closePopover()
            this.filteredAll()
        },

        closePopover() {
            this.popovervisibility.fungsi = false
            this.popovervisibility.tipe = false
            this.popovervisibility.area = false
            this.popovervisibility.unit = false
            this.popovervisibility.labarugi = false
        },

        setTableHeight() {
            // Dapatkan tinggi layar
            const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            let screenHeightDiv = screenHeight - 120;
            // Sesuaikan tinggi tabel sesuai dengan tinggi layar
            this.tableHeight = `${screenHeightDiv}px`;
        },

        applyFilter() {
            this.loadData()
        }

    },
    computed: {
        filteredOptionsFungsi() {
            const lowerSearch = String(this.searchTextFungsi2).toLowerCase();
            return this.options.fungsi.filter(
                (option) =>
                String(option.Fungsi).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsTipe() {
            const lowerSearch = String(this.searchTextTipe).toLowerCase();
            return this.options.tipe.filter(
                (option) =>
                String(option.Tipe).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsArea() {
            const lowerSearch = String(this.searchTextArea).toLowerCase();
            return this.options.salesarea.filter(
                (option) =>
                String(option.Value).toLowerCase().includes(lowerSearch) ||
                String(option.Name).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsUnit() {
            const lowerSearch = String(this.searchTextUnit2).toLowerCase();
            return this.options.unit.filter(
                (option) =>
                String(option.CostCenter).toLowerCase().includes(lowerSearch) ||
                String(option.UnitName).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsLabaRugi() {
            const lowerSearch = String(this.searchTextLabaRugi).toLowerCase();
            return this.options.labarugi.filter(
                (option) =>
                String(option.Value).toLowerCase().includes(lowerSearch)
            );
        },
        
        
    },
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.app-table {
    /*
    height: 100px;
    overflow-y: auto;
    */

  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius:4px;
}

.app-table td, .app-table th {
    
    vertical-align: middle;
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #F1F4F8/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color:rgba(240, 240, 240, 1)  /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 16px;
  text-align: center;
  background-color: #0B0468/*#0070C0*/;
  color: white;
}

.sticky-table-header {
    position: sticky;
    top: 0;
    background-color: #f8f8f8;
    /*z-index: 1000;*/
  }

.th-yellow {
    font-weight:bold;
    color:#1E1E1E !important;
    font-size:13px !important;
    background: #FFFF00 !important;
}

.el-dialog__body {
    word-break: normal !important;
}

.button-cell {
    border-radius: 2px;
    cursor: pointer;
    overflow:auto;
    -moz-box-sizing: border-box;
}

.button-cell:hover {
    background: #FFFF00 !important;
    border-radius: 2px;
    color:#1E1E1E !important;
    cursor: pointer;
}

.el-dialog {
    border-radius: 6px !important;
}


.checkbox-text  {
    max-width: 350px; /* Sesuaikan dengan lebar yang diinginkan */
    padding-top:5px;
    padding-bottom:5px;
    text-overflow: ellipsis;
   
    white-space: nowrap;  
}


.filter-popover {
  display: flex;
  align-items: center;
  justify-content: center; /* Mengatur horizontal alignment */
}

.filter-popover > * {
  margin-right: 0px; /* Sesuaikan dengan jarak yang diinginkan antar elemen */
  margin-left: 10px;
}


</style>